import { render, staticRenderFns } from "./BannersList.vue?vue&type=template&id=769e20c6&scoped=true"
import script from "./BannersList.vue?vue&type=script&lang=js"
export * from "./BannersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e20c6",
  null
  
)

export default component.exports